export default {
  common: {
    clearAll: 'Limpar TODOS',
    restart: 'Reiniciar'
  },
  download: {
    bodyText: 'Clique no link abaixo para baixar %{products}',
    bothProducts: 'PlayBase e/ou Nexus',
    bodyTextFromAcceptInvitation:
      'O processo levará algum tempo. Enquanto isso, você pode continuar usando Metrica Sports como de costume.',
    bodyTextFromDeclineInvitation:
      'Você recusou o convite! Clique em um link de Download abaixo para baixar o %{products}',
    bodyTextFromTrial:
      'Bem-vindo ao Seu Período de Teste! Verifique seu e-mail registrado para obter um link de verificação (verifique a pasta de spam).',
    bodyTitle: 'Download',
    bodyTitleFromAcceptInvitation: 'Estamos mudando sua conta',
    bodyTitleFromDeclineInvitation: 'Convite Recusado',
    bodyTitleFromTrial: 'Registo completo',
    play2: {
      description:
        'Metrica PlayBase é uma ferramenta de análise intuitiva projetada para treinadores amadores e prosumidores, pequenos clubes e analistas independentes. Simplifica o processo de avaliação de desempenho, tornando-o acessível para todos.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'O Metrica Nexus é feito sob medida para analistas e treinadores de elite que buscam informações abrangentes sobre desempenho. Com ferramentas avançadas ao seu alcance, você pode aprimorar as estratégias da equipe e alcançar o sucesso.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      'Obrigado por se registrar na Metrica Sports! Para começar com seu teste, baixe %{products}.'
  },
  error: {
    restart: 'Parece que está a tentar entrar em algo que ainda estamos a desenvolver...',
    tryAgainMsg:
      'Por favor tente novamente, se este erro continuar, contacte a equipa de apoio do Metrica Sports'
  },
  verifyEmail: {
    generateLink: 'Gerar uma nova ligação através do login na Play',
    readyToLogin: 'Está pronto para entrar na PLAY',
    successfully: 'Email verificado com sucesso',
    unsuccessfully: 'Erro de verificação de e-mail, token inválido'
  }
}
